import * as WS from '../webServices/cyMyManager';
import { formatDate } from '../webServices/cyMyManagerUtils';
type TableOrdiniProps = {
    ordine: WS.Plus.IF.AbbonamVendTest;
    passToModal: () => void;
};

export default function TableOrdini(props: TableOrdiniProps):JSX.Element {
    
    return (
        <tr onClick={props.passToModal} >
            <td className='table-cell-mobile'>
                <span className='table-label-mobile' style={{width: 'fit-content'}}>#{props.ordine.Numero}</span>
                <span className='table-title-mobile'>{props.ordine.desCliente}</span>
                <span className='table-subtitle-mobile'><strong>Abbonamento Acquistato:</strong>{props.ordine.desAbbonamento}</span>
                <span className='table-subtitle-mobile'><strong>Data acquisto:</strong>{formatDate(props.ordine.DataAbb)}</span>
                <span className='table-subtitle-mobile'><strong>Totale: </strong>€ {props.ordine.Prezzo.toFixed(2)}</span>
            </td>
        </tr>
    )
}